import { useEffect, useState } from 'react';
import axios from 'axios';
import { CONFIG } from 'variables/config';
import Card from 'components/card';
import { useNavigate, useParams } from 'react-router-dom';
import GoBack from 'components/actions/GoBack';
import {
    MdAdd,
    MdDisplaySettings,
    MdDoneOutline,
    MdOutlinePayment,
    MdOutlineRocketLaunch,
    MdOutlineWhatsapp,
} from 'react-icons/md';
import { getImage } from 'variables/images';
import { TbTargetArrow } from 'react-icons/tb';
import { useIndustries } from 'services/industryService';
import SignUpModal from 'views/admin/main/buyer/sellerOffer/components/SignUpModal';

const BuyerMarketPlacePage = () => {
    const { industries: industriesData, loading: industriesLoading } = useIndustries();
    const [user, setUser] = useState<any>(null);
    const [offer, setOffer] = useState<any>({});
    const [showSignUpModal, setShowSignUpModal] = useState(false);
    const params = useParams();
    const nav = useNavigate();

    const initUser = () => {
        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + localStorage.getItem('token'),
            },
        };
        axios
            .get(`${CONFIG.apiUrl}/user/me`, config)
            .then((res) => {
                setUser(res.data);
                if (res.data && res.data.type !== 'buyer') {
                    window.location.href = '/admin/my-request';
                }
            })
            .catch((err) => {
                console.log('No user info found', err);
            });
    };

    const getOffer = (id: string) => {
        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + localStorage.getItem('token'),
            },
        };
        axios
            .get(`${CONFIG.apiUrl}/seller-offer/marketplace/${id}`, config)
            .then((res) => {
                setOffer(res.data);
                console.log(res.data);
            })
            .catch((err) => {
                console.log('No user info found', err);
                //window.location.href = '/auth/sign-in';
            });
    };

    useEffect(() => {
        if (
            !localStorage.getItem('token') ||
            localStorage.getItem('token').length < 10
        )
            window.location.href = '/auth/sign-up';
        getOffer(params.id);
        initUser();
        // eslint-disable-next-line
    }, []);

    const InfoBox = (props: {
        icon?: any;
        title?: string;
        description?: string;
    }) => {
        const { icon, title, description } = props;
        return (
            <div className="w-full rounded-lg border p-4 dark:!bg-navy-700">
                <div className="grid grid-cols-12 gap-0">
                    <div className="col-span-1 text-gray-900">{icon}</div>
                    <h4 className="col-span-10 text-lg font-bold text-gray-900 dark:text-white">
                        {title}
                    </h4>
                </div>
                <p className="mt-[12px] whitespace-pre-line pr-2 text-sm text-gray-700 dark:text-white">
                    {description}
                </p>
            </div>
        );
    };

    function capitalizeFirstLetter(string: string) {
        if (!string) return '';
        return string.charAt(0).toUpperCase() + string.slice(1);
    }

    const GuestRegistration = () => {
        return (
            <div className="mb-4 mt-4 rounded-md border-l-4 border-yellow-500 bg-yellow-100 p-4 text-yellow-800">
                <p className="font-semibold">
                    Vous utilisez actuellement un compte invité 🚧
                </p>
                <p className="mt-1 text-sm">
                    Pour ne rien perdre et accéder à toutes les fonctionnalités,
                    rendez-vous dans vos <strong>paramètres de compte</strong>{' '}
                    afin d’ajouter votre adresse e-mail et vos informations
                    personnelles.
                </p>
                <p className="mt-2">
                    <a
                        href="#"
                        onClick={() => nav('/admin/settings')}
                        className="font-medium text-leadrs underline hover:text-blue-800"
                    >
                        ➜ Mettre à jour mon compte
                    </a>
                </p>
            </div>
        );
    };

    if (industriesLoading) {
        return (
            <div className="flex h-screen items-center justify-center">
                <div className="text-xl font-bold text-navy-700 dark:text-white">
                    Chargement des industries...
                </div>
            </div>
        );
    }

    return (
        <div>
            <GoBack />
            {user?.email?.includes('guest-') && <GuestRegistration />}
            <div className="mt-3 h-full w-full gap-2 rounded-[20px]">
                <Card
                    extra={
                        'relative w-full pb-[10px] pt-[10px] px-[29px] h-fit shadow shadow-3xl rounded-[20px] border'
                    }
                >
                    {/* Header */}
                    <div className="mt-1 flex gap-10">
                        <div>
                            {getImage(offer?.industry, offer?.subIndustry) ? (
                                <img
                                    src={getImage(
                                        offer?.industry,
                                        offer?.subIndustry
                                    )}
                                    className="mb-2 max-h-[500px] w-full rounded-xl"
                                    alt={`${offer?.industry} ${offer?.subIndustry}`}
                                />
                            ) : (
                                <div className="mb-2 flex h-[350px] w-[500px] items-center justify-center rounded-xl bg-gray-500">
                                    <p>
                                        {offer?.industry} - {offer?.subIndustry}
                                    </p>
                                </div>
                            )}
                            {/* CTAs */}
                            <div className="gap-3">
                                <div
                                    className="mx-auto flex h-[50px] justify-center gap-2 rounded-xl border bg-gray-50 px-4 hover:cursor-pointer hover:bg-gray-100"
                                    onClick={() =>
                                        window.open(
                                            'https://wa.me/447458107868 ',
                                            '_blank'
                                        )
                                    }
                                >
                                    <div className="flex  gap-2">
                                        <MdOutlineWhatsapp
                                            className="my-auto"
                                            size={25}
                                        />
                                        <p className="my-auto flex">
                                            En savoir plus sur cette offre
                                        </p>
                                    </div>
                                </div>
                                <div
                                    className="mx-auto mt-3 flex h-[50px] justify-center gap-2 rounded-xl border bg-gray-50 px-4 hover:cursor-pointer hover:bg-gray-100"
                                    onClick={() => nav('/admin/create-order')}
                                >
                                    <div className="flex gap-2">
                                        <MdAdd className="my-auto" size={25} />
                                        <p className="my-auto flex">
                                            Faire une demande de leads
                                        </p>
                                    </div>
                                </div>
                            </div>
                            {/* Infos */}
                            <div className="mt-3 w-full rounded-[20px] p-4 dark:!bg-navy-700">
                                <div className="grid grid-cols-12 gap-0">
                                    <div className="text-red-600900 col-span-1 text-3xl text-red-400">
                                        <TbTargetArrow />
                                    </div>
                                    <h4 className="col-span-10 text-lg font-bold dark:text-white">
                                        Pour qui sont ces leads ?
                                    </h4>
                                </div>
                                <p className="mt-[12px] whitespace-pre-line pr-2 text-sm">
                                    {capitalizeFirstLetter(
                                        industriesData.find(i => i.name === offer?.industry)
                                            ?.forWho
                                    )}
                                </p>
                            </div>
                        </div>
                        <div>
                            <p className="mt-5 text-xl text-navy-700 dark:text-white">
                                {offer?.subIndustry}
                            </p>
                            <h1 className="mt-2 text-2xl font-bold">
                                {offer?.industry}
                            </h1>
                            <p className="mb-5 text-sm font-bold">
                                #{offer?.offerBuyerNumber}
                            </p>
                            <div className="mb-3 mt-5 h-px w-full bg-gray-500"></div>
                            {/* Offer status */}
                            <div className="mt-2">
                                {/* {offer?.status === 'waiting_subscription' && (
                                    <div
                                        className="hover:cursor-pointer"
                                        onClick={() => {
                                            window.location.href =
                                                '/admin/subscribe';
                                        }}
                                    >
                                        <InfoBox
                                            icon={
                                                <MdOutlinePayment size={30} />
                                            }
                                            title={'Abonnement nécessaire'}
                                            description={`Vous devez être abonné pour pouvoir publier cette offre.`}
                                        />
                                        <button
                                            className="linear mx-auto mt-2 w-full rounded-xl border-2 border-leadrs px-5 py-2 text-sm font-medium text-leadrs transition duration-200 hover:bg-blue-600/5 active:bg-blue-700/5"
                                            onClick={() => {
                                                window.location.href =
                                                    '/admin/subscribe';
                                            }}
                                        >
                                            S'abonner
                                        </button>
                                    </div>
                                )} */}
                                {offer?.status === 'on_market' &&
                                    user &&
                                    !user.isValidated && (
                                        <InfoBox
                                            icon={
                                                <MdDisplaySettings size={30} />
                                            }
                                            title={'En attente de validation'}
                                            description={`Votre compte doit être validé par un administrateur, votre offre sera publiée une fois que ce sera fait.`}
                                        />
                                    )}
                                {offer?.status === 'on_market' && (
                                    <InfoBox
                                        icon={<MdOutlinePayment size={30} />}
                                        title={'En attente de paiement'}
                                        description={`Vous pouvez commander ${
                                            offer?.weeklyQuantity
                                        } leads à ${offer?.buyerPrice.toFixed(
                                            2
                                        )}€ l'unité. Votre campagne commence une fois la commande payée.`}
                                    />
                                )}
                                {offer?.status === 'on_market' && (
                                    <button
                                        className="data-rewardful linear mt-2 w-full rounded-xl border-2 border-leadrs px-5 py-2 text-sm font-medium text-leadrs transition duration-200 hover:bg-blue-600/5 active:bg-blue-700/5"
                                        onClick={() => {
                                            // Check if user is a guest
                                            if (user?.email?.includes('guest-')) {
                                                setShowSignUpModal(true);
                                            } else {
                                                window.location.href = `${CONFIG.apiUrl}/stripe/checkout/${offer?._id}/${user._id}`;
                                            }
                                        }}
                                    >
                                        Payer{' '}
                                        {offer?.buyerPrice.toFixed(2) *
                                            offer?.weeklyQuantity}
                                        €
                                    </button>
                                )}
                                {offer?.status === 'running' && (
                                    <>
                                        <p className="mb-3 ml-2 text-gray-700">
                                            💡 Délai de livraison : jusqu’à 2
                                            semaines après réception du
                                            paiement, variable selon le volume
                                            commandé.
                                        </p>
                                        <InfoBox
                                            icon={
                                                <MdOutlineRocketLaunch
                                                    size={30}
                                                />
                                            }
                                            title={'Mission en cours'}
                                            description={`Vous avez déjà reçu ${
                                                offer?.leadsGenerated
                                            } leads pour cette mission. Cela représente ${
                                                offer?.leadsGenerated *
                                                offer?.buyerPrice.toFixed(2)
                                            }€.`}
                                        />
                                    </>
                                )}
                                {offer?.status === 'done' && (
                                    <InfoBox
                                        icon={<MdDoneOutline size={30} />}
                                        title={'Mission terminée'}
                                        description={`Vous avez généré ${
                                            offer?.leadsGenerated
                                        } leads pour un total de ${
                                            offer?.leadsGenerated *
                                            offer?.buyerPrice.toFixed(2)
                                        } . Profitez de cette traction et cherchez un autre acheteur avec le même besoin`}
                                    />
                                )}
                            </div>
                            <p className="mt-3 text-lg font-bold">
                                Détails de l'offre
                            </p>
                            <p className="mt-3 text-sm">
                                {
                                    industriesData.find(i => i.name === offer?.industry)
                                        ?.description
                                }
                            </p>
                            <div className="mt-5 space-y-3">
                                <div className="flex items-center justify-between">
                                    <p className="text-sm font-bold">
                                        Prix unitaire
                                    </p>
                                    <p className="text-sm">
                                        {offer?.buyerPrice?.toFixed(2)} €
                                    </p>
                                </div>

                                <div className="flex items-center justify-between">
                                    <p className="text-sm font-bold">
                                        Quantité
                                    </p>
                                    <p className="text-sm">
                                        {offer?.weeklyQuantity} leads
                                    </p>
                                </div>

                                <div className="flex items-center justify-between">
                                    <p className="text-sm font-bold">
                                        Champs de données
                                    </p>
                                    <p className="text-right text-sm">
                                        {offer?.fields?.join(', ')}
                                    </p>
                                </div>

                                <div className="flex items-center justify-between">
                                    <p className="text-sm font-bold">
                                        Canaux d'acquisition
                                    </p>
                                    <p className="text-right text-sm">
                                        {offer?.channels?.join(', ')}
                                    </p>
                                </div>

                                <div className="flex items-center justify-between">
                                    <p className="text-sm font-bold">Besoin</p>
                                    <p className="text-right text-sm">
                                        {offer?.type}
                                    </p>
                                </div>

                                <div className="flex items-center justify-between">
                                    <p className="text-sm font-bold">
                                        Départements
                                    </p>
                                    <p className="text-right text-sm">
                                        {offer?.regions?.join(', ')}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </Card>
            </div>
            <SignUpModal
                isOpen={showSignUpModal}
                onClose={() => setShowSignUpModal(false)}
            />
        </div>
    );
};

export default BuyerMarketPlacePage;
